import { render, staticRenderFns } from "./Dynamsoft.vue?vue&type=template&id=3881b62f&scoped=true&"
import script from "./Dynamsoft.vue?vue&type=script&lang=js&"
export * from "./Dynamsoft.vue?vue&type=script&lang=js&"
import style0 from "./Dynamsoft.vue?vue&type=style&index=0&id=3881b62f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3881b62f",
  null
  
)

export default component.exports